import { FindItemMethod } from '../types/sharetribe/listing';
import { useShopConfig } from './shopConfig';
import { useCurrentUserPermissions } from './useUserPermissions';

interface AllowedFindItemMethods {
  shouldAllowSearch: boolean;
  shouldAllowCannotFind: boolean;
  shouldAllowOrderHistory: boolean;
  shouldAllowISO: boolean;
}

export const useAllowedFindItemMethods = (): AllowedFindItemMethods => {
  const shopConfig = useShopConfig();
  const { isLoggedInAsLimitedUser } = useCurrentUserPermissions();
  const { listingFlowConfig, shopifyDomain } = shopConfig;
  const { allowedFindItemMethods } = listingFlowConfig;
  const shouldAllowSearch =
    allowedFindItemMethods.includes(FindItemMethod.Manual) || isLoggedInAsLimitedUser;
  const shouldAllowCannotFind = allowedFindItemMethods.includes(FindItemMethod.CannotFind);
  const shouldAllowOrderHistory =
    allowedFindItemMethods.includes(FindItemMethod.EmailAccount) ||
    allowedFindItemMethods.includes(FindItemMethod.OrderNumber);

  // ISO is only support for Shopify shops as of 8/4/25
  const shouldAllowISO = shouldAllowSearch && !!shopifyDomain;

  return { shouldAllowSearch, shouldAllowCannotFind, shouldAllowOrderHistory, shouldAllowISO };
};
